// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

Vue.mixin({
  beforeDestroy: function () {
    if (typeof this.clearDelay === 'function') {
      this.clearDelay();
    }
  }
});

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#424969",
        apply: colors.green.darken1,
        cancel: colors.red.darken1,
        alertblue: colors.blue.darken2,
        backblue: colors.blue.lighten2,
        positive: "#4db2a1"
      },
    },
  }
};

export default new Vuetify(opts);
